module.exports = {
  input: require('./input'),
  output: require('./output')
}



//////////////////
// WEBPACK FOOTER
// ./~/bitcoinjs-lib/src/templates/multisig/index.js
// module id = 113
// module chunks = 0